<template>
  <div class="mb-2">
    <button class="btn btn-link w-100 text-start" @click="open = !open">
      <strong>{{ faq.question }}</strong>
    </button>
    <transition name="fade">
      <div v-if="open" class="ms-3">{{ faq.answer }}</div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'FaqItem',
  props: {
    faq: Object,
    index: Number
  },
  data() {
    return {
      open: false
    };
  }
}
</script>
